import React, { useRef } from 'react';
import { MetaPixel } from './components/MetaPixel';
import { FloatingCta } from './components/FloatingCta';
import { PurchasePopup } from './components/PurchasePopup';
import { Hero } from './components/sections/Hero';
import { Problem } from './components/sections/Problem';
import { Pathway } from './components/sections/Pathway';
import { BeforeAfter } from './components/sections/BeforeAfter';
import { Volumes } from './components/sections/Volumes';
import { Bonuses } from './components/sections/Bonuses';
import { Testimonials } from './components/sections/Testimonials';
import { Offer } from './components/sections/Offer';
import { Different } from './components/sections/Different';
import { Author } from './components/sections/Author';
import { Guarantee } from './components/sections/Guarantee';
import { Faq } from './components/sections/Faq';
import { FinalCta } from './components/sections/FinalCta';
import { Footer } from './components/sections/Footer';
export function App() {
  const firstCtaRef = useRef<HTMLAnchorElement>(null);
  return <div className="w-full overflow-x-hidden bg-ink-900 font-sans" data-id="element-0" data-mp="3mlj8uuvtnd32">
      <MetaPixel data-id="element-1" data-mp="3mjq45l4rr2xp" />
      <Hero ctaRef={firstCtaRef} data-id="element-2" data-mp="3mj6jhwnqi0fz" />
      <main data-id="element-3" data-mp="3rbzlwdvqcwow">
        <Problem data-id="element-4" data-mp="3rdatkosaqola" />
        <Pathway data-id="element-5" data-mp="3rcsulke91w9o" />
        <BeforeAfter data-id="element-6" data-mp="3recbnd7qcbci" />
        <Volumes data-id="element-7" data-mp="5otf64sd496" />
        <Bonuses data-id="element-8" data-mp="67yhm9c7y5s" />
        <Testimonials data-id="element-9" data-mp="4n53zyrel9i" />
        <Offer data-id="element-10" data-mp="56lhc8rh1lf" />
        <Different data-id="element-11" data-mp="7st1bvnjh3n" />
        <Author data-id="element-12" data-mp="2zld1r8m3ndb0" />
        <Guarantee data-id="element-13" data-mp="2zlv8x0aavbxp" />
        <Faq data-id="element-14" data-mp="2zmemk4sx3e5x" />
        <FinalCta data-id="element-15" data-mp="2zmwguvw0rib7" />
      </main>
      <Footer data-id="element-16" data-mp="33mowfsjtyoq2" />
      <FloatingCta anchorRef={firstCtaRef} data-id="element-17" data-mp="33m5cy7ej7s9x" />
      <PurchasePopup data-id="element-18" data-mp="33mym1f0yqtv8" />
    </div>;
}